import React, { useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import ls from "localstorage-slim";
import { loadCss, formatDateToTime } from "../../helpers/function";
import LoadingTable from "../components/LoadingTable";
import appConfig from "../../config/appConfig";
import Pagination from "../components/Pagination";
import EmptyTable from "../components/EmptyTable";
import InfirmationTable from "../components/InfirmationTable";
import { ERROR_401 } from "../../config/errorPage";
import { verifyPermission } from "../../helpers/permission";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import HtmlDescription from "../components/DescriptionDetail/HtmlDescription";
import HtmlDescriptionModal from "../components/DescriptionDetail/HtmlDescriptionModal";

loadCss("/assets/plugins/custom/datatables/datatables.bundle.css");

const DefinitivelyDeclassifiedClaims = (props) => {
  const { t, ready } = useTranslation();
  document.title = "Satis client - " + (ready ? t("Réclamations déclassées définitivement") : "");

  const canList = verifyPermission(props.userPermissions, "list-definitively-declassified-claims");

  if (!canList) {
    window.location.href = ERROR_401;
  }

  const [load, setLoad] = useState(true);
  const [showList, setShowList] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [numberPage, setNumberPage] = useState(0);
  const [activeNumberPage, setActiveNumberPage] = useState(1);
  const [numberPerPage, setNumberPerPage] = useState(10);
  const [searchable, setSearchable] = useState("");
  const [currentMessage, setCurrentMessage] = useState("");

  const fetchDefinitivelyDeclassifiedClaims = () => {
    if (verifyTokenExpire()) {
      setLoad(true);
      const params = {
        page: activeNumberPage,
        size: numberPerPage,
      };
      if (searchable?.length > 0) params["key"] = searchable;

      axios
        .get(`${appConfig.apiDomaine}/my/claims/definitively-declassified`, { params })
        .then((response) => {
          setLoad(false);
          setShowList(response.data.data || []);
          setTotalData(response.data.total || 0);
          setNumberPage(response.data.last_page || 0);
        })
        .catch(() => {
          setLoad(false);
        });
    }
  };

  useEffect(() => {
    fetchDefinitivelyDeclassifiedClaims();
  }, [activeNumberPage, numberPerPage, searchable]);

  const handleDownload = (format) => {
    if (verifyTokenExpire()) {
      const token = ls.get("token");

      axios({
        url: `${appConfig.apiDomaine}/my/claims/definitively-declassified/download/${format}`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          const extension = format === "pdf" ? "pdf" : "xlsx";
          link.setAttribute("download", `reclamations_declassees_definitivement.${extension}`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Erreur de téléchargement :", error);
        });
    }
  };

  const showModal = (message) => {
    setCurrentMessage(message);
    document.getElementById("button_modal_desc").click();
  };

  const pages = Array.from({ length: numberPage }, (_, i) => i);

  if (!ready) return null;

  return (
    <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container kt-container--fluid">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">{t("Collecte")}</h3>
            <span className="kt-subheader__separator kt-hidden" />
            <div className="kt-subheader__breadcrumbs">
              <a href="#home" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter" />
              </a>
              <span className="kt-subheader__breadcrumbs-separator" />
              <span className="kt-subheader__breadcrumbs-link">
                {t("Réclamations déclassées définitivement")}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <InfirmationTable information={t("Liste des réclamations définitivement déclassées (Consultation en lecture seule)")} />

        <div className="kt-portlet">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title">{t("Réclamations déclassées définitivement")}</h3>
            </div>
          </div>

          <div className="kt-portlet__body">
            <div className="row mb-4 align-items-center">
              <div className="col-sm-6 text-left">
                <label className="mb-0">
                  {t("Recherche")}:
                  <input
                    type="text"
                    className="form-control form-control-sm ml-2 d-inline-block"
                    style={{ width: "auto" }}
                    value={searchable}
                    onChange={(e) => setSearchable(e.target.value)}
                  />
                </label>
              </div>

              {/* Boutons identiques au style ClaimReportingUemoaSix */}
              <div className="col-sm-6 text-right">
                <button
                  type="button"
                  className="btn btn-secondary ml-3"
                  onClick={() => handleDownload("excel")}
                >
                  EXCEL
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ml-3"
                  onClick={() => handleDownload("pdf")}
                >
                  PDF
                </button>
              </div>
            </div>

            {load ? (
              <LoadingTable />
            ) : (
              <div className="dataTables_wrapper dt-bootstrap4">
                <table className="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>{t("Référence")}</th>
                      <th>{t("Réclamant")}</th>
                      <th>{t("Date de déclassement définitif")}</th>
                      <th>{t("Objet de réclamation")}</th>
                      <th>{t("Nombre de relances")}</th>
                      <th>{t("Description")}</th>
                      <th style={{ textAlign: "center" }}>{t("Statut")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {showList.length > 0 ? (
                      showList.map((claim, index) => (
                        <tr key={index}>
                          <td>{claim.reference || "-"}</td>
                          <td>
                            {claim.claimer?.raison_sociale
                              ? claim.claimer.raison_sociale
                              : `${claim.claimer?.lastname || ""} ${claim.claimer?.firstname || ""}`}
                          </td>
                          <td>{formatDateToTime(claim.definitive_declassification_date || claim.declassification_date)}</td>
                          <td>{claim.claim_object?.name?.fr || claim.claim_object?.name || "-"}</td>
                          <td className="text-center">
                            <span className="badge badge-warning font-weight-bold">
                              {claim.claimer_follow_ups?.length || 0}
                            </span>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <HtmlDescription onClick={() => showModal(claim.description || "-")} />
                          </td>
                          <td className="text-center">
                            <span className="badge badge-danger font-weight-bold">
                              {t("Déclassée définitivement")}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <EmptyTable />
                    )}
                  </tbody>
                </table>

                <button
                  id="button_modal_desc"
                  type="button"
                  className="btn btn-secondary d-none"
                  data-toggle="modal"
                  data-target="#message_email"
                />
                <HtmlDescriptionModal title={t("Description")} message={currentMessage} />

                <div className="row">
                  <div className="col-sm-12 col-md-5">
                    <div className="dataTables_info">
                      {t("Affichage de")} {showList.length} {t("sur")} {totalData} {t("données")}
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-7">
                    <Pagination
                      numberPerPage={numberPerPage}
                      onChangeNumberPerPage={(e) => setNumberPerPage(parseInt(e.target.value))}
                      activeNumberPage={activeNumberPage}
                      onClickPreviousPage={() => setActiveNumberPage((p) => Math.max(p - 1, 1))}
                      pages={pages}
                      onClickPage={(_, page) => setActiveNumberPage(page + 1)}
                      numberPage={numberPage}
                      onClickNextPage={() => setActiveNumberPage((p) => Math.min(p + 1, numberPage))}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
});

export default connect(mapStateToProps)(DefinitivelyDeclassifiedClaims);